<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><a id="pg7">Contents</a></p><a id="pg7">
</a><p class="toc"><a id="pg7"></a><a href="#/05_acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/06_introduction">Introduction</a></p>
<p class="toc1"><a href="#/07_chapter01">1. Pioneer Days</a></p>
<p class="toc"><a href="#/08_chapter02">2. Downtown</a></p>
<p class="toc"><span href="#/09_chapter03" title="Link target outside of Sample">3. Restaurant Empires</span></p>
<p class="toc"><span href="#/10_chapter04" title="Link target outside of Sample">4. In the Neighborhoods</span></p>
<p class="toc"><span href="#/11_chapter05" title="Link target outside of Sample">5. Along the Highways</span></p>
<p class="toc"><span href="#/12_chapter06" title="Link target outside of Sample">6. A Touch of the Exotic</span></p>
<p class="toc"><span href="#/13_chapter07" title="Link target outside of Sample">7. Recent Departures and a Few Survivors</span></p>
<p class="toc1"><span href="#/14_bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/15_abouttheauthors" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_toc.vue?483bfa24